import { getAuth } from 'firebase/auth';
import { stimuliBackendBaseUrl } from '../stimuli/stimulusUploads';

/**
 * JSON calls to vasi-backend admin endpoints. Same base URL
 * (REACT_APP_VASI_BACKEND_URL) and `Authorization: Bearer <Firebase ID
 * token>` as the stimulus uploads. Errors carry the HTTP status and the
 * backend's `detail` message.
 */
export class BackendError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'BackendError';
    this.status = status;
  }
}

export async function currentIdToken(auth = getAuth()) {
  const user = auth?.currentUser;
  if (!user) throw new BackendError('You are signed out. Sign in again.', 401);
  return user.getIdToken();
}

export async function backendRequest(path, {
  method = 'GET',
  body,
  token,
  baseUrl = stimuliBackendBaseUrl(),
  fetchImpl = globalThis.fetch,
} = {}) {
  const idToken = token ?? await currentIdToken();
  const headers = { Authorization: `Bearer ${idToken}` };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  const response = await fetchImpl(`${baseUrl.replace(/\/+$/, '')}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  let payload = null;
  try {
    payload = await response.json();
  } catch (_error) {
    payload = null;
  }
  if (!response.ok) {
    const detail = typeof payload?.detail === 'string' && payload.detail
      ? payload.detail
      : `Request failed (HTTP ${response.status}).`;
    throw new BackendError(detail, response.status);
  }
  return payload;
}
